import React from 'react';
import styled from 'styled-components';

import { getScoreColor } from 'modules/health/helpers/getScoreColor';
import { headerData } from 'modules/health/mockData/mockData';

import AvgPoints from './AvgPoints';
import ChangeInScore from './ChangeInScore';
import MembersCount from './MembersCount';
import ScoreRing from './ScoreRing';
import TopBar from './TopBar';

const Header = () => {
  const {
    logoUrl,
    period,
    year,
    teamMembers,
    corporateAccountName,
    wellscore,
    goalWellScore,
    changeInScore,
    avgPointsEarned,
  } = headerData;

  const scoreColor = getScoreColor(wellscore);

  return (
    <>
      <TopBar
        logoUrl={logoUrl}
        period={period}
        year={year}
        corporateAccountName={corporateAccountName}
      />
      <Wrapper>
        <Card>
          <MembersCount teamMembersCount={teamMembers} />
          <Title>Health Index</Title>

          <ContentGrid>
            <ChangeInScore
              thisMonth={changeInScore.thisMonth}
              thisQuarter={changeInScore.thisQuarter}
              thisYear={changeInScore.thisYear}
            />
            <ScoreRing
              score={wellscore}
              goalScore={goalWellScore}
              color={scoreColor}
            />
            <AvgPoints
              thisMonth={avgPointsEarned.thisMonth}
              thisQuarter={avgPointsEarned.thisQuarter}
              thisYear={avgPointsEarned.thisYear}
            />
          </ContentGrid>
        </Card>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const Card = styled.div`
  box-sizing: border-box;
  position: relative;
  padding: 90px 60px 0;
  width: 100%;
  color: ${({ theme }) => theme.colors.white};
  min-height: 1000px;
  background:
    url('/images/health_index_background_additional.png') center bottom
      no-repeat,
    url('/images/health_index_background.png') 39% 50% / contain no-repeat
      ${({ theme }) => theme.colors.primary};
`;

const Title = styled.p`
  color: #fff;
  text-align: center;
  font-size: 40px;
  line-height: 21px;
  margin-bottom: 95px;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  gap: 115px;
`;

export default Header;
